import MOA from "../../../../src/pages/moa/moa.js";
import * as React from 'react';
export default {
  MOA,
  React
};